import { useEffect, useState } from 'react';
import { getWallet } from '../cabinet.api';
import { WalletInfo } from '../cabinet.schemas';

export function WalletPage() {
  const [wallet, setWallet] = useState<WalletInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getWallet()
      .then(setWallet)
      .catch(() => setWallet(null))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="cabinet-page">
      <h1>Кошелек и реферальная программа</h1>

      {isLoading ? (
        <section className="cabinet-loading-panel" role="status" aria-live="polite">
          <span aria-hidden="true" />
          <strong>Загружаем баланс</strong>
        </section>
      ) : null}

      {!isLoading && wallet ? (
        <>
          <section className="cabinet-panel referral-rework-banner">
            <div>
              <span>Реферальная система</span>
              <h2>Мы полностью перерабатываем реферальную программу</h2>
              <p>Скоро вернемся с очень хорошими новостями: условия станут понятнее, начисления удобнее, а бонусы заметнее.</p>
            </div>
            <strong>Скоро</strong>
          </section>

          <div className="wallet-grid">
            <section className="cabinet-panel balance-card">
              <span>Баланс</span>
              <strong>{wallet.balance} {wallet.currency}</strong>
              <p>Можно использовать для оплаты до 50% подписки</p>
            </section>
          </div>
        </>
      ) : null}

      {!isLoading && !wallet ? (
        <section className="cabinet-panel">Не удалось загрузить баланс</section>
      ) : null}
    </div>
  );
}
